import { memo } from 'react'
import { Chip } from 'src/components/shared/Chip'
import { colors } from 'src/theme'
import tw from 'twin.macro'
import { CustomerCollectedDataStatus } from 'src/constants/customer/enums'
import { customerCollectedDataStatusTitle } from 'src/constants/customer/constants'

interface Props {
  status: CustomerCollectedDataStatus
  expiresSoon?: boolean
}

const expiresSoonStatus = {
  color: colors.COLORS_ORANGE_500,
  text: 'Expires soon',
  bgStyle: tw`bg-[#FFEED6]`,
}

const stepStatusMap = {
  [CustomerCollectedDataStatus.Completed]: {
    color: colors.COLORS_GREEN_500,
    text: customerCollectedDataStatusTitle[CustomerCollectedDataStatus.Completed],
    bgStyle: tw`bg-[rgba(230, 249, 233, 1)]`,
  },
  [CustomerCollectedDataStatus.Created]: {
    color: colors.SHADES_GREY_500,
    text: customerCollectedDataStatusTitle[CustomerCollectedDataStatus.Created],
    bgStyle: tw`bg-[rgba(218, 217, 224, 1)]`,
  },
  [CustomerCollectedDataStatus.Failed]: {
    color: colors.COLORS_RED_500,
    text: customerCollectedDataStatusTitle[CustomerCollectedDataStatus.Failed],
    bgStyle: tw`bg-[rgba(255, 232, 238, 1)]`,
  },
  [CustomerCollectedDataStatus.WaitingForInternalApproval]: {
    color: colors.SHADES_GREY_500,
    text: customerCollectedDataStatusTitle[CustomerCollectedDataStatus.WaitingForInternalApproval],
    bgStyle: tw`bg-[rgba(218, 217, 224, 1)]`,
  },
  [CustomerCollectedDataStatus.InProgress]: {
    color: colors.COLORS_BLUE_500,
    text: customerCollectedDataStatusTitle[CustomerCollectedDataStatus.InProgress],
    bgStyle: tw`bg-[rgba(216, 229, 255, 1)]`,
  },
  [CustomerCollectedDataStatus.Archived]: {
    color: colors.SHADES_GREY_500,
    text: customerCollectedDataStatusTitle[CustomerCollectedDataStatus.Archived],
    bgStyle: tw`bg-[rgba(218, 217, 224, 1)]`,
  },
  [CustomerCollectedDataStatus.Expired]: {
    color: colors.COLORS_RED_500,
    text: customerCollectedDataStatusTitle[CustomerCollectedDataStatus.Expired],
    bgStyle: tw`bg-[rgba(255, 232, 238, 1)]`,
  },
}

const CustomerStepStatusChipComponent = ({ status, expiresSoon }: Props) => {
  const params = expiresSoon ? expiresSoonStatus : stepStatusMap[status]

  return (
    <div css={tw`flex items-center`}>
      <div css={tw`py-1 rounded-[10px]`}>
        <Chip className={params.bgStyle} textColor={params.color} text={params.text} />
      </div>
    </div>
  )
}

export const CustomerStepStatusChip = memo(CustomerStepStatusChipComponent)
